<div class="grid grid-cols-3 gap-1 md:gap-6">
  <app-required-input-wrapper
    [label]="'input.day' | translate"
    [control]="dateForm.controls.date"
    [touched]="dateForm.controls.date.touched"
    [isDisabled]="dateForm.controls.date.disabled">
    <input
      type="text"
      app-base-input
      app-number-only
      inputmode="numeric"
      [formControl]="dateForm.controls.date"
      (focus)="onTouch(true)" />
  </app-required-input-wrapper>
  <div class="grid">
    <app-select
      [label]="'input.month' | translate"
      [formControl]="dateForm.controls.month"
      required>
      <ng-container *ngIf="isMobile" mobile>
        <h1 class="prose-display-lg px-4 font-semibold" translate>input.month</h1>
        <div class="grid gap-6">
          <app-option value="1">January</app-option>
          <app-option value="2">February</app-option>
          <app-option value="3">March</app-option>
          <app-option value="4">April</app-option>
          <app-option value="5">May</app-option>
          <app-option value="6">June</app-option>
          <app-option value="7">July</app-option>
          <app-option value="8">August</app-option>
          <app-option value="9">September</app-option>
          <app-option value="10">October</app-option>
          <app-option value="11">November</app-option>
          <app-option value="12">December</app-option>
        </div>
      </ng-container>
      <ng-container *ngIf="!isMobile">
        <app-option value="1">January</app-option>
        <app-option value="2">February</app-option>
        <app-option value="3">March</app-option>
        <app-option value="4">April</app-option>
        <app-option value="5">May</app-option>
        <app-option value="6">June</app-option>
        <app-option value="7">July</app-option>
        <app-option value="8">August</app-option>
        <app-option value="9">September</app-option>
        <app-option value="10">October</app-option>
        <app-option value="11">November</app-option>
        <app-option value="12">December</app-option>
      </ng-container>
    </app-select>
    <app-display-errors
      [control]="dateForm.controls.month"
      *ngIf="dateForm.controls.month.touched" />
  </div>
  <app-required-input-wrapper
    [label]="'input.year' | translate"
    [control]="dateForm.controls.year"
    [touched]="dateForm.controls.year.touched"
    [isDisabled]="dateForm.controls.year.disabled">
    <input
      type="text"
      app-base-input
      app-number-only
      inputmode="numeric"
      [formControl]="dateForm.controls.year"
      (focus)="onTouch(true)" />
  </app-required-input-wrapper>
</div>
